import moment from 'moment'

import { CellValue } from '../types'
import { useTranslation } from 'react-i18n-lite'
import { formatDateTime, YesObject } from '@yes.technology/react-toolkit'
import { AllowedLocales } from 'shared/utils/date/formatDate'

export type FieldType = 'DATETIME' | 'RELATION' | 'STRING' | 'UUID'

type UseFormattedValueProps = {
  value: CellValue
  type?: FieldType
  dateOptions?: Intl.DateTimeFormatOptions
}

const formatArrayValue = (value: YesObject[]) =>
  value.map(({ des }) => des).join(', ')

const formatObjectValue = (value: object) => JSON.stringify(value)

export default function useFormattedValue({
  value,
  type = 'STRING',
  dateOptions
}: UseFormattedValueProps): string | null {
  const { language } = useTranslation()

  if (!value) return null

  if (Array.isArray(value)) {
    return formatArrayValue(value)
  }

  if (typeof value === 'object') {
    return formatObjectValue(value)
  }

  if (type === 'DATETIME' && moment(value).isValid()) {
    const date = new Date(value)
    return dateOptions
      ? date.toLocaleString(language, {
          ...dateOptions,
          timeZone: dateOptions.timeZone || window.waTimezone
        })
      : formatDateTime(date, {
          locale: language as AllowedLocales,
          format: 'date-time',
          timezone: window.waTimezone
        })
  }

  return String(value)
}
